import { useState, useEffect } from 'react';

export const useURLSync = (initialFilters) => {
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    // Read from URL on mount
    const params = new URLSearchParams(window.location.search);
    const urlFilters = { ...initialFilters };

    params.forEach((value, key) => {
      if (urlFilters.hasOwnProperty(key)) {
        urlFilters[key] = value;
      }
    });

    setFilters(urlFilters);
  }, []);

  useEffect(() => {
    // Update URL when filters change
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        // if (key === 'sortBy' && value === 'createdAt') return;
        // if (key === 'sortOrder' && value === 'desc') return;
        params.set(key, value);
      }
    });

    const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
    window.history.replaceState({}, '', newUrl);
  }, [filters]);

  return [filters, setFilters];
};
